import { useDispatch, useSelector } from "react-redux";
import { updateCustomerDetail } from "../../redux/slices/customerSlice";
import useTranslation from "../hooks/useTranslation";

const CustomerDetailForm = ({ requiredFields = {}, uneditable = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const customer = useSelector((state) => state.customer);

  const handleChange = (e) => {
    if (uneditable) return;

    let value = e.target.value;

    // Normalisasi nomor HP: ubah +62 menjadi 08
    if (e.target.name === "phone") {
      value = value.replace(/^\+62/, "0");
      // Jika dimulai dengan 62 (tanpa +), ubah jadi 08
      if (value.startsWith("62") && !value.startsWith("0")) {
        value = "0" + value.substring(2);
      }
    }

    dispatch(updateCustomerDetail({ [e.target.name]: value }));
  };

  const inputClass = `w-full border rounded-md p-2 ${uneditable ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`;

  return (
    <form className="space-y-4">
      {requiredFields.name && <div>
        <label className="block text-gray-700">{t("customerDetailForm.fullName")}</label>
        <input
          type="text"
          name="fullName"
          value={customer.fullName}
          onChange={handleChange}
          readOnly={uneditable}
          required
          className={inputClass}
          placeholder={t("customerDetailForm.johnDoePlaceholder")}
        />
      </div>}
      {requiredFields.phone && <div>
        <label className="block text-gray-700">{t("customerDetailForm.phone")}</label>
        <input
          type="tel"
          name="phone"
          value={customer.phone}
          onChange={handleChange}
          readOnly={uneditable}
          required
          className={inputClass}
          placeholder={t("customerDetailForm.phonePlaceholder")}
        />
        <p className="text-xs text-gray-500 mt-1">{t("customerDetailForm.phoneHelper")}</p>
      </div>}
      {requiredFields.email && <div>
        <label className="block text-gray-700">{t("common.email")}</label>
        <input
          type="email"
          name="email"
          value={customer.email}
          onChange={handleChange}
          readOnly={uneditable}
          required
          className={inputClass}
          placeholder={t("customerDetailForm.emailPlaceholder")}
        />
        <p className="text-xs text-gray-500 mt-1">{t("customerDetailForm.emailHelper")}</p>
      </div>}
    </form>
  );
};

export default CustomerDetailForm;
